import React, { useState, useEffect } from 'react';
import {
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Button,
  Spinner,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
} from '@chakra-ui/react';
import { Plus, SquarePen, Trash2 } from 'lucide-react';
import { toast } from 'react-toastify';
import Pagination from '../../../utils/pagination/Pagination';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { SolarInverterForm } from './SolarInverterForm'; // Ensure this path is correct
import PanelList from '../panel/PanelList';
import { deleteSolarInverter } from '../../../redux/api/solarInverterApi/SolarInverterApi.js';
import { deleteSolarInverterAction } from '../../../redux/reduxSlice/SolarInverterSlice.js';
import { useSelector, useDispatch } from 'react-redux';
import {getSolarInverter} from '../../../redux/reduxApi/solarInverterReduxApi.js';
import { formatDate } from '../../../utils/commonFunction/CommonFunction.js';
export default function InverterList() {
  const [isSolarInverter, setIsSolarInverter] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(5);
  const [inverterData, setInverterData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [itemId, setItemId] = useState("");
  const [dataToEdit, setDataToEdit] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const inverterDataFromStore = useSelector((state) => state.solarInverter.solarInverter);
    const [itemsPerPage, setItemsPerPage] = useState(30);

  const dispatch = useDispatch();
console.log("inverterDataFromStore", inverterDataFromStore)
  useEffect(() => {
    if (inverterDataFromStore && inverterDataFromStore.length > 0) {
      setInverterData(inverterDataFromStore);
      console.log("inter",inverterData)
    }
  }, [inverterDataFromStore]);

  useEffect(() => {
    const page = 1;
    setLoading(true);
    dispatch(getSolarInverter(page)).finally(() => setLoading(false));
  }, []);

  const openTrash = () => {
    setIsOpen(true);
  };

  const closeTrash = () => {
    setIsOpen(false);
  };

  const openSolarInverterDrawer = () => {
    setIsSolarInverter(true);
    setIsUpdateMode(false); // Ensure update mode is off when creating a new item
    setDataToEdit({}); // Clear any existing data to edit
  };

  const closeSolarInverter = () => {
    setIsSolarInverter(false);
  };

  const handleDelete = () => {
    setShowProgressBar(true);
    setLoading(true);
    const idsToDelete = selectedRows.length === 0 ? [deleteId] : selectedRows;
    Promise.all(idsToDelete.map((id) => deleteSolarInverter(id)))
      .then(() => {
        setInverterData((prevData) =>
          prevData.filter((item) => !idsToDelete.includes(item?.ROWID))
        );
        dispatch(deleteSolarInverterAction(idsToDelete));
        toast.success("Row deleted successfully");
      })
      .catch((error) => {
        console.log(error);
        toast.error("Row not deleted");
      })
      .finally(() => {
        setShowProgressBar(false);
        setLoading(false);
        closeTrash();
        setSelectedRows([]);
        setDeleteId("");
      });
  };

  const handleRowSelect = (ROWID) => {
    const isSelected = selectedRows.includes(ROWID);
    let newSelectedRows = [];
    if (!isSelected) {
      newSelectedRows = [...selectedRows, ROWID];
    } else {
      newSelectedRows = selectedRows.filter((rowItem) => rowItem !== ROWID);
    }
    setSelectedRows(newSelectedRows);
    setDeleteId(newSelectedRows.join(','));
  };

  const handleSelectAllRows = () => {
    const allSelected = selectedRows.length === inverterData.length;
    let newSelectedRows = [];
    if (!allSelected) {
      newSelectedRows = inverterData.map((item) => item?.ROWID);
    }
    setSelectedRows(newSelectedRows);
  };

  return (
    <>
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="purple.500" />
        </div>
      )}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody></ModalBody>
          <ModalFooter>
            <Button className='create-button' mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className='cancel-button' onClick={closeTrash}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <div className="d-flex justify-content-end">
        <button className="new-button mx-2" onClick={openSolarInverterDrawer}>
          <Plus size="18px" />
          <span className="ms-1">New</span>
        </button>
      </div>
      <div className="custom-scroll leadListContainer"  style={{ maxHeight: "72vh",width:"100%", position: "relative", overflowY: "scroll" ,overflowX:'hidden', scrollbarColor: '#A0AEC0 #EDF2F7',
    scrollbarWidth: '10px'  }}>
        <TableContainer className='card card-detail mt-1'>
          <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="download-table-xls-button d-none"
            table="table-to-xls"
            filename="Inverter List"
            sheet="tablexls"
            buttonText="Export"
          />
          <Table id="table-to-xls" className='leadNoPadding' variant='simple' size='sm' stickyHeader style={{ whiteSpace: 'nowrap', backgroundColor: 'white' }}>
            <Thead>
              <Tr className="tr-border">
                <Th className='py-1 th-color' style={{ width: '50px' }}>
                  <Checkbox isChecked={selectedRows?.length === inverterData?.length} onChange={handleSelectAllRows} />
                </Th>
                <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Actions</Th>
                <Th className='py-1 th-color' style={{ width: '150px' }}>Inverter Brand Name</Th>
                <Th className='py-1 th-color' style={{ width: '150px' }}>Inverter Brand Description</Th>
                <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Created Time</Th>
                <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Modified Time</Th>
                <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Created By</Th>
              </Tr>
            </Thead>
            <Tbody>
              {inverterData && inverterData.slice((currentPage - 1) * 30, currentPage * 30).map((item, idx) => (
                <Tr className='tr-border' key={idx}>
                  <Td className='font-colors py-1'>
                    <Checkbox isChecked={selectedRows.includes(item.ROWID)} onChange={() => handleRowSelect(item.ROWID)} />
                  </Td>
                  <Td className='d-flex' style={{ borderBottom: 'none' }}>
                    <SquarePen color="#ff176b" size="16px" strokeWidth="1" className='mx-1' onClick={() => { openSolarInverterDrawer(); setDataToEdit(item); setIsUpdateMode(true); setItemId(item?.ROWID); }} />
                    <Trash2 color="#ff176b" size="16px" strokeWidth="1" onClick={(e) => { openTrash(e); setDeleteId(item?.ROWID); }} />
                  </Td>
                  <Td className='font-colors py-1'>{item?.inverterName}</Td>
                  <Td className='font-colors py-1'>{item?.inverterDescription}</Td>
                  <Td className='font-colors py-1'>{formatDate(item?.CREATEDTIME)}</Td>
                  <Td className='font-colors py-1'>{formatDate(item?.MODIFIEDTIME)}</Td>
                  <Td className='font-colors py-1'>{item?.createdBy || '-'}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </div>
      <div className="footer d-flex fixed-bottom start-20">
        <div className="total" style={{ marginLeft: "20%", marginTop: "15px" }}>
          <p className="fw-semibold">Total Count: {inverterData.length}</p>
        </div>
        <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
           <Pagination
              totalPages={Math.ceil(inverterData.length / itemsPerPage)}
              onPageChange={(no) => setCurrentPage(no)}
            />
        </div>
      </div>
      <SolarInverterForm
        isSolarInverter={isSolarInverter}
        closeSolarInverter={closeSolarInverter}
        dataToEdit={dataToEdit}
        isUpdateMode={isUpdateMode}
        setIsUpdateMode={setIsUpdateMode}
        solarInverterId={itemId}
      />
    </>
  );
}
